import {
  Component,
  ElementRef,
  forwardRef,
  HostBinding,
  Input,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { WarehouseSelectComponent } from '../warehouse-select.component';
import {
  StoreClasses,
  StoreControlName,
  StoreDebounceTime,
  StoreLabel,
  StoreMaxLength,
  StoreMinLength,
  StorePlaceholder,
} from './store-select.constants';
import { StoreErrors } from 'app/shared/errors/error-messages';
import { getWarehouseDescription } from '../warehouse-select.utils';
import { ECategoryOfWarehouse, WarehouseResult } from '@models';
import { AddressService } from '@services';

@Component({
  selector: 'app-store-select',
  templateUrl: '../warehouse-select.component.html',
  styleUrls: ['../warehouse-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StoreSelectComponent),
      multi: true,
    },
  ],
})
export class StoreSelectComponent extends WarehouseSelectComponent {
  WarehouseErrors = StoreErrors;

  @Input() placeholder: string = StorePlaceholder;

  @Input() label: string = StoreLabel;

  @Input() testId: string = StoreControlName;

  @Input() minLength: number = StoreMinLength;

  @Input() maxLength: number = StoreMaxLength;

  @Input() debounceTime: number = StoreDebounceTime;
  @Input() forSender: boolean = false;

  @Input() getWarehouseDescription = getWarehouseDescription;

  @Input()
  @HostBinding('class')
  classList = StoreClasses;

  constructor(
    protected addressService: AddressService,
    protected element: ElementRef,
  ) {
    super(addressService, element);
  }

  getWarehouses(cityRef: string): Observable<WarehouseResult[]> {
    return this.addressService.getWarehouses(
      cityRef,
      undefined,
      undefined,
      this.forSender,
      ECategoryOfWarehouse.Store,
    );
  }
}
